import { REGIONS } from 'consts';

import { TFieldProps } from 'types';

export const retailerGenericFields: TFieldProps[] = [{
  type: TFieldProps.type.TreeSelect,
  name: ['retailerValues', 'regions'],
  label: 'Regions',
  treeData: REGIONS,
  maxTagCount: 2,
  maxTagPlaceholder: (omittedValues) => `+ ${omittedValues.length} Regions ...`,
  rules: [{
    type: 'array',
    min: 1,
    required: true,
    message: 'Select minimum 1 region!',
  }],
}, {
  type: TFieldProps.type.DatePicker,
  label: 'Effective From',
  name: ['retailerValues', 'effectiveFrom'],
  showTime: true,
}, {
  type: TFieldProps.type.DatePicker,
  name: ['retailerValues', 'effectiveTo'],
  label: 'Effective To',
  showTime: true,
}, {
  type: TFieldProps.type.Checkbox,
  name: ['retailerValues', 'isContainPii'],
  label: 'Contain PII',
  tooltip: 'Don’t show receipts from this retailer to Operators',
}, {
  type: TFieldProps.type.Checkbox,
  name: ['retailerValues', 'isExcludedFromCompanyPostProcessors'],
  label: 'Exclude Company receipt post-processing',
  tooltip: 'If checked, receipt post-processors based on a Retailer Company, will not be executed',
}];

export const retailerPartnerFields = (isEnabledBaseIssuance: boolean): TFieldProps[] => [
  // {
  //   type: TFieldProps.type.Checkbox,
  //   name: ['partnerValues', 'isManualThreshold'],
  //   label: 'Threshold for manual review',
  // },
  // {
  //   type: TFieldProps.type.Number,
  //   name: ['partnerValues', 'manualThreshold'],
  //   label: '',
  //   disabled: !isManualThreshold,
  //   rules: [{
  //     required: isManualThreshold,
  //     message: 'Manual Threshold is required!',
  //   }],
  // },
  {
    type: TFieldProps.type.Checkbox,
    name: ['partnerValues', 'isEnabledBaseIssuance'],
    label: 'Active (required for base issuance offers)',
    tooltip: 'If checked, the retailer will be added to the Issued Partners list',
  }, {
    type: TFieldProps.type.Text,
    name: ['partnerValues', 'sponsorCode'],
    label: 'Sponsor Code',
    disabled: !isEnabledBaseIssuance,
    rules: [{
      required: isEnabledBaseIssuance,
      message: 'Sponsor Code is required!',
    }],
  }];
